import { render, staticRenderFns } from "./ClientChooser.vue?vue&type=template&id=45d3617c&scoped=true&"
import script from "./ClientChooser.vue?vue&type=script&lang=ts&"
export * from "./ClientChooser.vue?vue&type=script&lang=ts&"
import style0 from "./ClientChooser.vue?vue&type=style&index=0&id=45d3617c&prod&scoped=true&lang=css&"
import style1 from "./ClientChooser.vue?vue&type=style&index=1&id=45d3617c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d3617c",
  null
  
)

export default component.exports